/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export type UrlArgumentValue = string | string[] | number | boolean | null;
export type UrlArguments = Record<string, UrlArgumentValue>;

export function parseUrlArguments(args: UrlArguments): string[][] {
    const parsed: string[][] = [];
    Object.entries(args).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
            parsed.push([key, `${value}`]);
            return;
        }

        value.forEach(v => {
            parsed.push([key, `${v}`]);
        });
    });

    return parsed;
}